<template>
  <div class="wrapper">
    <div class="form">
      <van-form @submit="showDalog">
        <div class="formWrapper">  
          <div class="panel">
            <div class="title">激活码信息</div>
            <van-field class="_van_btn" v-model="formData.code" name="code" label="激活码" required placeholder="请输入激活码"
              :rules="[{ required: true, message: '请填写激活码' }]">
              <van-icon @click="() => codeScan(1)" slot="right-icon" name="scan" />
              <van-button @click="()=>cameraScan(1, 1)" :icon="carema_src" slot="button" style="margin-top: -6px;"
                size="mini" hairline round type="danger">
                拍照识别
              </van-button>
            </van-field>

            <van-field class="_van_btn" v-if="showCode2" v-model="formData.code2" name="code" label="激活码"
              placeholder="请输入激活码">
              <van-icon @click="() => codeScan(2)" slot="right-icon" name="scan" />
                <van-button @click="()=>cameraScan(2, 1)" :icon="carema_src" slot="button" style="margin-top: -6px;"
                size="mini" hairline round type="danger">
                拍照识别
              </van-button>
            </van-field>
            <van-field class="_van_btn" v-if="showCode3" v-model="formData.code3" name="code" label="激活码"
              placeholder="请输入激活码">
              <van-icon @click="() => codeScan(3)" slot="right-icon" name="scan" />
              <van-button @click="()=>cameraScan(3, 1)" :icon="carema_src" slot="button" style="margin-top: -6px;"
                size="mini" hairline round type="danger">
                拍照识别
              </van-button>
            </van-field>
            <van-field class="_van_btn" v-if="showCode4" v-model="formData.code4" name="code" label="激活码"
              placeholder="请输入激活码">
              <van-icon @click="() => codeScan(4)" slot="right-icon" name="scan" />
              <van-button @click="()=>cameraScan(4, 1)" :icon="carema_src" slot="button" style="margin-top: -6px;"
                size="mini" hairline round type="danger">
                拍照识别
              </van-button>
            </van-field>
            <van-field class="_van_btn" v-if="showCode5" v-model="formData.code5" name="code" label="激活码"
              placeholder="请输入激活码">
              <van-icon @click="() => codeScan(5)" slot="right-icon" name="scan" />
              <van-button @click="()=>cameraScan(5, 1)" :icon="carema_src" slot="button" style="margin-top: -6px;"
                size="mini" hairline round type="danger">
                拍照识别
              </van-button>
            </van-field>
            <van-field class="_van_btn" v-if="showCode6" v-model="formData.code6" name="code" label="激活码"
              placeholder="请输入激活码">
              <van-icon @click="() => codeScan(6)" slot="right-icon" name="scan" />
              <van-button @click="()=>cameraScan(6, 1)" :icon="carema_src" slot="button" style="margin-top: -6px;"
                size="mini" hairline round type="danger">
                拍照识别
              </van-button>
            </van-field>
            <van-field class="_van_btn" v-if="showCode7" v-model="formData.code7" name="code" label="激活码"
              placeholder="请输入激活码">
              <van-icon @click="() => codeScan(7)" slot="right-icon" name="scan" />
              <van-button @click="()=>cameraScan(7, 1)" :icon="carema_src" slot="button" style="margin-top: -6px;"
                size="mini" hairline round type="danger">
                拍照识别
              </van-button>
            </van-field>
            <van-field class="_van_btn" v-if="showCode8" v-model="formData.code8" name="code" label="激活码"
              placeholder="请输入激活码">
              <van-icon @click="() => codeScan(8)" slot="right-icon" name="scan" />
              <van-button @click="()=>cameraScan(8, 1)" :icon="carema_src" slot="button" style="margin-top: -6px;"
                size="mini" hairline round type="danger">
                拍照识别
              </van-button>
            </van-field>
            <van-field class="_van_btn" v-if="showCode9" v-model="formData.code9" name="code" label="激活码"
              placeholder="请输入激活码">
              <van-icon @click="() => codeScan(9)" slot="right-icon" name="scan" />
              <van-button @click="()=>cameraScan(9, 1)" :icon="carema_src" slot="button" style="margin-top: -6px;"
                size="mini" hairline round type="danger">
                拍照识别
              </van-button>
            </van-field>
            <van-field class="_van_btn" v-if="showCode10" v-model="formData.code10" name="code" label="激活码"
              placeholder="请输入激活码">
              <van-icon @click="() => codeScan(10)" slot="right-icon" name="scan" />
              <van-button @click="()=>cameraScan(10, 1)" :icon="carema_src" slot="button" style="margin-top: -6px;"
                size="mini" hairline round type="danger">
                拍照识别
              </van-button>
            </van-field>
            <div class="icon-box">
              <van-icon v-if="!isMaxCodes" name="add-o" @click="addActiveCodeInput" />
              <van-icon v-if="isMaxCodes || showCode2 === true" name="close" @click="reduceActiveCodeInput" />
            </div>
          </div>
          <div class="panel">
            <div class="title">产品信息</div>
            <van-field class="picker-field" :class="brandName && 'picker-inputed'" clickable name="picker" disabled
              :value="brandName" required label="品牌" :rules="[{ required: true, message: '请选择品牌' }]" placeholder="点击选品牌"
              @click="showPicker = true" />
            <van-field v-model="formData.model" name="model" readonly label="型号" required placeholder="请输入型号"
              @click="modelItemClick" />
            <van-popup v-model="showVersionPicker" round position="bottom">
              <van-picker show-toolbar title="选择型号" :columns="filterVersionCol" @cancel="showVersionPicker = false"
                @confirm="onConfirm3">
                <slot slot="title">
                  <van-search style="padding: 0" v-model="searchValue" placeholder="输入机型" />
                </slot>
                <template #option="item">
                  <div @click="pickerItemClick(item)">{{ item }}</div>
                </template>
              </van-picker>
            </van-popup>
            <van-field v-model="formData.memory" name="memory" label="内存" required placeholder="请输入内存"
              :rules="[{ required: true, message: '请填写内存' }]" />
            <van-field class="_van_btn" v-model="formData.serialNum" name="serialNum" label="串号" required
              placeholder="请输入串号(苹果设备请输入序列号)" :rules="[{ required: true, message: '请输入串号(苹果设备请输入序列号)' }]">
              <van-icon @click="serialScan" slot="right-icon" name="scan" />
              <van-button @click="()=>cameraScan(0, 2)" :icon="carema_src" slot="button" size="mini" hairline round
                type="danger">
                拍照识别
              </van-button>
            </van-field>
          </div>
          <div class="panel">
            <div class="title">用户信息</div>
            <van-field v-model="formData.userName" name="userName" label="姓名" required placeholder="请输入姓名"
              :rules="[{ required: true, message: '请填写姓名' }]" />
            <van-field v-model="formData.userPhone" type="tel" name="userPhone" label="手机号" required
              placeholder="请输入手机号" :maxlength="11" :rules="[
                { required: true, message: '请填写手机号' },
                {
                  message: '手机号码格式错误,请重新输入',
                  pattern: /0?(13|14|15|16|17|18|19)[0-9]{9}/,
                },
              ]" />
            <van-field class="picker-field" :class="purchasTime && 'picker-inputed'" clickable name="picker" disabled
              :value="purchasTime" required label="购机时间" :rules="[{ required: true, message: '请选择购机时间' }]"
              placeholder="点击选择购机时间" @click="showTime = true" />
            <van-field v-model="formData.money" type="number" name="money" label="购机价格" required placeholder="请输入购机价格"
              :rules="[{ required: true, message: '请填写购机价格' }]" />
          </div>
          <div class="panel">
            <div class="title">门店信息</div>
            <van-field v-model="formData.sellName" name="sellName" label="销售员姓名" required placeholder="请输入销售员姓名"
              :rules="[{ required: true, message: '请填写销售员姓名' }]">
            </van-field>
            <van-field v-model="formData.sellPhone" type="tel" name="sellPhone" label="销售员手机号" required :maxlength="11"
              placeholder="请输入销售员手机号" :rules="[
                { required: true, message: '请填写销售员手机号' },
                {
                  message: '手机号码格式错误,请重新输入',
                  pattern: /0?(13|14|15|16|17|18|19)[0-9]{9}/,
                },
              ]" />
          </div>
          <div class="panel">
            <div class="title">凭证信息</div>
            <div class="discription">
              提示:
              <p>1、完整主屏幕，常亮状态下*#06#显示出串号（手机务必照全）</p>
              <p>
                2、完整购机凭证盖门店销售章，需填写用户姓名、电话、日期、机型、串号、价格，不可遮挡；
              </p>
              <p>
                3、完整保修卡盖章，需填写用户姓名、电话、日期、串码标，不可遮挡；
              </p>
              <p>4、百度搜索显示北京时间。</p>
            </div>
            <van-button v-if="codeCertificate" style="width: 100%" @click="openPreview([codeCertificate])">
              预览图片
            </van-button>
            <van-uploader accept="image/*" :after-read="afterRead" :max-size="20 * 1024 * 1024" @oversize="overSizeTip">
              <img v-if="codeCertificate" style="width: 100%" :src="codeCertificate" />
              <van-button v-else class="upladerBtn" icon="plus" type="primary"></van-button>
            </van-uploader>
          </div>
          <div class="icon-box" v-if="!uploadImg2">
            <!-- 当没有第二张图片时，按键在第一张图片panel后面 -->
            <van-icon size='25' name="add-o" @click="addUploadImg" />
          </div>
          <div class="panel" v-if="uploadImg2">
            <van-button v-if="formData.codeCertificate3" style="width: 100%" @click="
                (e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  openPreview([codeCertificate3]);
                }
              ">
              预览图片
            </van-button>
            <van-uploader accept="image/*" :after-read="afterRead2" :max-size="20 * 1024 * 1024"
              @oversize="overSizeTip">
              <img v-if="formData.codeCertificate3" style="width: 100%" :src="codeCertificate3" />
              <van-button v-else class="upladerBtn" icon="plus" type="primary"></van-button>
            </van-uploader>
          </div>
          <div class="icon-box" v-if="uploadImg2 && !uploadImg3">
            <!-- 当有第二张图片但没有第三张图片时，按键在第二张图片panel后面 -->
            <van-icon size='25' style="margin-right: 20px" name="add-o" @click="addUploadImg2" />
            <van-icon size='25' name="close" @click="reduceUploadImg" />
          </div>
          <div class="panel" v-if="uploadImg3">
            <van-button v-if="formData.codeCertificate4" style="width: 100%" @click="
                (e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  openPreview([codeCertificate4]);
                }
              ">
              预览图片
            </van-button>
            <van-uploader accept="image/*" :after-read="afterRead3" :max-size="20 * 1024 * 1024"
              @oversize="overSizeTip">
              <img v-if="formData.codeCertificate4" style="width: 100%" :src="codeCertificate4" />
              <van-button v-else class="upladerBtn" icon="plus" type="primary"></van-button>
            </van-uploader>
          </div>
          <div class="icon-box" v-if="uploadImg3">
            <!-- 当有第三张图片时，按键在第三张图片panel后面 -->
            <van-icon size='25' name="close" @click="reduceUploadImg2" />
          </div>
        </div>

        <div style="margin: 16px">
          <van-button round block type="danger" native-type="submit">激活</van-button>
        </div>
      </van-form>
      <van-popup v-model="showTime" position="bottom">
        <van-datetime-picker v-model="formData.purchasTime" type="date" @confirm="onConfirm2" @cancel="showTime = false"
          title="选择年月日" />
      </van-popup>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="brandList" value-key="brandName" @confirm="onConfirm"
          @cancel="showPicker = false">
        </van-picker>
      </van-popup>
    </div>
    <loadingMask :isShow="showLoding" />
    <a class="copyright" href="http://beian.miit.gov.cn">蜀ICP备2020033555号-1
    </a>
    <div class="copyright" style="margin-top: 0">
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002003407" style="
          display: inline-block;
          text-decoration: none;
          height: 20px;
          line-height: 20px;
        "><img src="https://www.servicefun.cn/static/img/beian.png" style="float: left" />
        <p style="
            float: left;
            height: 20px;
            line-height: 20px;
            margin: 0px 0px 0px 5px;
            color: #2b3135;
          ">
          川公网安备 51019002003407号
        </p>
      </a>
    </div>
    <van-dialog v-model="dialogShow" title="服务须知" confirmButtonText="同意并提交" show-cancel-button @confirm="onSubmit"
      @cancel="dialogShow = false">
      <div class="dialog">
        <p>1、被保障商品保修范围以品牌官方保修政策为准；</p>
        <p>2、被保障商品经判定以下情况本服务即失效：</p>
        <p class="indent">
          （1）严重毁灭性机器（例如：弯曲、变形，断裂、缺件、穿孔、进液、分离、粉碎等）；
        </p>
        <p class="indent">（2）在非官方授权售后有过维修（私拆、私修）；</p>
        <p class="indent">
          （3）手机遗失或者零部件缺损及本服务范围外的所有损失；
        </p>
        <p>
          3、请在服务前务必解除机器锁屏密码或告知我方，若因密码锁定而导致我方无法检测故障，我方有权不予提供本服务且不承担任何责任；
        </p>
        <p>
          4、被保障机器已使用约定服务次数或者已超出约定服务期限，本服务即终止；
        </p>
        <p>5、折叠屏手机和三星手机的曲面屏系列不在保障范围；</p>
        <p>6、本服务在约定售卖有效期内，同一商品仅能购买一次服务，多买无效；</p>
        <p>7、若通过作假等非真实有效的方式套取服务，一经查实将追究相关责任。</p>
        <p>
          8、本服务产品适用于激活15天以内安卓手机以及激活3天以内iPhone手机（存量机产品除外）
        </p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
  import {
    uploadImg,
    saveUserInfo,
    getBrandList,
    getWxToken,
    getUserInfo,
    getVersionList,
  } from "@/api";
  import loadingMask from "@/components/loadingMask.vue";
  import {
    checkImgFun
  } from "@/utils/common.js";
  import dayjs from "dayjs";
  import {
    baseURL
  } from "@/config";
  import {
    getScanCode
  } from "@/utils/wxSDK";
  import {
    timeFormat,
    openPreview
  } from "@/utils";
  import {
    Form
  } from "vant";
  export default {
    name: "activationCode",
    components: {
      loadingMask,
    },
    computed: {
      filterVersionCol: function() {
        return this.searchValue ?
          this.versionList.filter((v) => v.includes(this.searchValue)) :
          this.versionList;
      },
      isMaxCodes: function() {
        return this.showCode10;
      },
    },
    data() {
      return {
        carema_src: require("@/assets/carema.png"),
        baseURL,
        showCode2: false,
        showCode3: false,
        showCode4: false,
        showCode5: false,
        showCode6: false,
        showCode7: false,
        showCode8: false,
        showCode9: false,
        showCode10: false,
        uploadImg2: false,
        uploadImg3: false,
        formData: {
          code: "",
          code2: "",
          code3: "",
          code4: "",
          code5: "",
          code6: "",
          code7: "",
          code8: "",
          code9: "",
          code10: "",
          codeCertificate: "",
          codeCertificate3: "",
          codeCertificate4: "",
          serialNum: "",
          userName: "",
          userPhone: "",
          money: "",
          brandId: "",
          purchasTime: new Date(),
          sellName: "",
          sellPhone: "",
          memory: "",
          model: "",
        },
        purchasTime: dayjs().format("YYYY-M-D"),
        codeCertificate: "",
        codeCertificate3: "",
        codeCertificate4: "",
        brandName: "",
        showVersionPicker: false,
        versionList: [],
        brandList: [],
        showLoding: false,
        showPicker: false,
        showTime: false,
        searchValue: "",
        dialogShow: false,
      };
    },
    async mounted() {
      window.document.title = "服务卡激活";
      await this.getBrandListFun();
      await this.getVersionListFun();
      
      // 先从localStorage中读取数据
      if (!!window.localStorage.getItem('formData')) {
        const formData = window.localStorage.getItem('formData');
        console.log("formData - - -", formData);
        this.formData = JSON.parse(formData)

        window.localStorage.removeItem('formData');
      }

      // 恢复显示状态
      if (!!window.localStorage.getItem('showCodeStates')) {
        const showCodeStates = JSON.parse(window.localStorage.getItem('showCodeStates'));
        this.showCode2 = showCodeStates.showCode2 || false;
        this.showCode3 = showCodeStates.showCode3 || false;
        this.showCode4 = showCodeStates.showCode4 || false;
        this.showCode5 = showCodeStates.showCode5 || false;
        this.showCode6 = showCodeStates.showCode6 || false;
        this.showCode7 = showCodeStates.showCode7 || false;
        this.showCode8 = showCodeStates.showCode8 || false;
        this.showCode9 = showCodeStates.showCode9 || false;
        this.showCode10 = showCodeStates.showCode10 || false;
        window.localStorage.removeItem('showCodeStates');
      }

      if (!!window.localStorage.getItem('_scanCode_1_1')) {
        const _scanCode_1_1 = window.localStorage.getItem('_scanCode_1_1');
        this.formData.code = !!_scanCode_1_1 ? _scanCode_1_1 : (!!this.formData.code ? this.formData.code : '')
        window.localStorage.removeItem('_scanCode_1_1');
      }
      if (!!window.localStorage.getItem('_scanCode_2_1')) {
        const _scanCode_2_1 = window.localStorage.getItem('_scanCode_2_1');
        this.formData.code2 = !!_scanCode_2_1 ? _scanCode_2_1 : (!!this.formData.code2 ? this.formData.code2 : '')
        window.localStorage.removeItem('_scanCode_2_1');
      }
      if (!!window.localStorage.getItem('_scanCode_3_1')) {
        const _scanCode_3_1 = window.localStorage.getItem('_scanCode_3_1');
        this.formData.code3 = !!_scanCode_3_1 ? _scanCode_3_1 : (!!this.formData.code3 ? this.formData.code3 : '')
        window.localStorage.removeItem('_scanCode_3_1');
      }
      if (!!window.localStorage.getItem('_scanCode_4_1')) {
        const _scanCode_4_1 = window.localStorage.getItem('_scanCode_4_1');
        this.formData.code4 = !!_scanCode_4_1 ? _scanCode_4_1 : (!!this.formData.code4 ? this.formData.code4 : '')
        window.localStorage.removeItem('_scanCode_4_1');
      }
      if (!!window.localStorage.getItem('_scanCode_5_1')) {
        const _scanCode_5_1 = window.localStorage.getItem('_scanCode_5_1');
        this.formData.code5 = !!_scanCode_5_1 ? _scanCode_5_1 : (!!this.formData.code5 ? this.formData.code5 : '')
        window.localStorage.removeItem('_scanCode_5_1');
      }
      if (!!window.localStorage.getItem('_scanCode_6_1')) {
        const _scanCode_6_1 = window.localStorage.getItem('_scanCode_6_1');
        this.formData.code6 = !!_scanCode_6_1 ? _scanCode_6_1 : (!!this.formData.code6 ? this.formData.code6 : '')
        window.localStorage.removeItem('_scanCode_6_1');
      }
      if (!!window.localStorage.getItem('_scanCode_7_1')) {
        const _scanCode_7_1 = window.localStorage.getItem('_scanCode_7_1');
        this.formData.code7 = !!_scanCode_7_1 ? _scanCode_7_1 : (!!this.formData.code7 ? this.formData.code7 : '')
        window.localStorage.removeItem('_scanCode_7_1');
      }
      if (!!window.localStorage.getItem('_scanCode_8_1')) {
        const _scanCode_8_1 = window.localStorage.getItem('_scanCode_8_1');
        this.formData.code8 = !!_scanCode_8_1 ? _scanCode_8_1 : (!!this.formData.code8 ? this.formData.code8 : '')
        window.localStorage.removeItem('_scanCode_8_1');
      }
      if (!!window.localStorage.getItem('_scanCode_9_1')) {
        const _scanCode_9_1 = window.localStorage.getItem('_scanCode_9_1');
        this.formData.code9 = !!_scanCode_9_1 ? _scanCode_9_1 : (!!this.formData.code9 ? this.formData.code9 : '')
        window.localStorage.removeItem('_scanCode_9_1');
      }
      if (!!window.localStorage.getItem('_scanCode_10_1')) {
        const _scanCode_10_1 = window.localStorage.getItem('_scanCode_10_1');
        this.formData.code10 = !!_scanCode_10_1 ? _scanCode_10_1 : (!!this.formData.code10 ? this.formData.code10 : '')
        window.localStorage.removeItem('_scanCode_10_1');
      }
      if (!!window.localStorage.getItem('_scanCode_2')) {
        const _scanCode_2 = window.localStorage.getItem('_scanCode_2');
        this.formData.serialNum = !!_scanCode_2 ? _scanCode_2 : (!!this.formData.serialNum ? this.formData.serialNum :
          '')
        window.localStorage.removeItem('_scanCode_2');
      }
      
      // 然后从URL参数中获取数据并覆盖localStorage中的数据
      this.updateFormFromUrl();
      
      // 监听路由变化，实时更新表单
      this.$router.beforeEach((to, from, next) => {
        this.updateFormFromUrl();
        next();
      });
    },
    methods: {
      // 从URL参数更新表单数据
      updateFormFromUrl() {
        // 直接从window.location中获取URL参数，确保能获取到最新的参数
        const url = window.location.href;
        const hashPart = url.split('#')[1];
        let params = {};
        
        if (hashPart) {
          const paramsPart = hashPart.split('?')[1];
          if (paramsPart) {
            const paramPairs = paramsPart.split('&');
            paramPairs.forEach(pair => {
              const [key, value] = pair.split('=');
              params[key] = decodeURIComponent(value);
            });
          }
        }
        
        console.log('params', params);
        
        if (params.code) {
          const codes = params.code.split(',');
          if (codes.length > 0) {
            this.formData.code = codes[0];
          }
          if (codes.length > 1) {
            this.formData.code2 = codes[1];
            this.showCode2 = true;
          }
          if (codes.length > 2) {
            this.formData.code3 = codes[2];
            this.showCode3 = true;
          }
          if (codes.length > 3) {
            this.formData.code4 = codes[3];
            this.showCode4 = true;
          }
          if (codes.length > 4) {
            this.formData.code5 = codes[4];
            this.showCode5 = true;
          }
          if (codes.length > 5) {
            this.formData.code6 = codes[5];
            this.showCode6 = true;
          }
          if (codes.length > 6) {
            this.formData.code7 = codes[6];
            this.showCode7 = true;
          }
          if (codes.length > 7) {
            this.formData.code8 = codes[7];
            this.showCode8 = true;
          }
          if (codes.length > 8) {
            this.formData.code9 = codes[8];
            this.showCode9 = true;
          }
          if (codes.length > 9) {
            this.formData.code10 = codes[9];
            this.showCode10 = true;
          }
        }
        if (params.brandId) {
          this.formData.brandId = params.brandId;
        }
        if (params.brandName) {
          this.brandName =  decodeURIComponent(params.brandName);
        }
        if (params.model) {
          this.formData.model = params.model;
        }
        if (params.memory) {
          this.formData.memory = decodeURIComponent(params.memory);
        }
        if (params.money) {
          this.formData.money = decodeURIComponent(params.money);
        }
        if (params.serialNum) {
          this.formData.serialNum = params.serialNum;
        }
        if (params.userName) {
          this.formData.userName = params.userName;
        }
        if (params.userPhone) {
          this.formData.userPhone = params.userPhone;
        }
        if (params.purchasTime) {
          this.formData.purchasTime = new Date(params.purchasTime);
          this.purchasTime = params.purchasTime;
        }
        if (params.sellName) {
          this.formData.sellName = decodeURIComponent(params.sellName);
        }
        if (params.sellPhone) {
          this.formData.sellPhone = params.sellPhone;
        }
      },
      openPreview,
      addUploadImg() {
        this.uploadImg2 = true
        this.formData.codeCertificate3 = ''
      },
      reduceUploadImg() {
        // 如果有关闭第三个图片，先关闭第三个
        if (this.uploadImg3) {
          this.uploadImg3 = false
          this.formData.codeCertificate4 = ''
        } else {
          // 否则关闭第二个图片
          this.uploadImg2 = false
          this.formData.codeCertificate3 = ''
        }
      },
      addUploadImg2() {
        this.uploadImg3 = true
        this.formData.codeCertificate4 = ''
      },
      reduceUploadImg2() {
        // 关闭第三个图片
        this.uploadImg3 = false
        this.formData.codeCertificate4 = ''
        // 关闭第三个后，第二个图片仍然存在，所以会显示添加按钮
      },
      onConfirm3() {
        if (!this.searchValue) {
          this.$toast("请输入型号");
          return;
        }
        this.formData.model = this.searchValue;
        this.showVersionPicker = false;
      },
      addActiveCodeInput() {
        if (!this.showCode2) {
          this.showCode2 = true;
        } else if (!this.showCode3) {
          this.showCode3 = true;
        } else if (!this.showCode4) {
          this.showCode4 = true;
        } else if (!this.showCode5) {
          this.showCode5 = true;
        } else if (!this.showCode6) {
          this.showCode6 = true;
        } else if (!this.showCode7) {
          this.showCode7 = true;
        } else if (!this.showCode8) {
          this.showCode8 = true;
        } else if (!this.showCode9) {
          this.showCode9 = true;
        } else if (!this.showCode10) {
          this.showCode10 = true;
        }
      },
      reduceActiveCodeInput() {
        if (this.showCode10) {
          this.showCode10 = false;
          this.formData.code10 = "";
        } else if (this.showCode9) {
          this.showCode9 = false;
          this.formData.code9 = "";
        } else if (this.showCode8) {
          this.showCode8 = false;
          this.formData.code8 = "";
        } else if (this.showCode7) {
          this.showCode7 = false;
          this.formData.code7 = "";
        } else if (this.showCode6) {
          this.showCode6 = false;
          this.formData.code6 = "";
        } else if (this.showCode5) {
          this.showCode5 = false;
          this.formData.code5 = "";
        } else if (this.showCode4) {
          this.showCode4 = false;
          this.formData.code4 = "";
        } else if (this.showCode3) {
          this.showCode3 = false;
          this.formData.code3 = "";
        } else {
          this.showCode2 = false;
          this.formData.code2 = "";
        }
      },
      overSizeTip() {
        this.$toast("上传图片不能超过20M");
      },
      modelItemClick() {
        this.showVersionPicker = true;
        this.searchValue = "";
      },
      getBrandListFun() {
        getBrandList().then((res) => {
          const response = res.data;
          if (response.code === "200") {
            this.brandList = response.data;
          }
        });
      },
      getVersionListFun() {
        getVersionList().then((res) => {
          const response = res.data;
          if (response.code === "200") {
            this.versionList = response.data.map((v) => {
              return v.version;
            });
          }
        });
      },
      pickerItemClick(item) {
        this.searchValue = item;
      },
      codeScan(inputNum) {
        getScanCode().then((res) => {
          console.log("res - - -", res);
          if(inputNum==1){
            this.formData.code = res;
          }else{
            this.formData["code" + inputNum] = res;
          }
        })
      },

      cameraScan(inputNum, code_type) {

        // console.log("this.formData - - - ", this.formData);

        const formData = JSON.stringify(JSON.parse(JSON.stringify(this.formData)))
        window.localStorage.setItem('formData', formData)

        // 保存显示状态
        const showCodeStates = {
          showCode2: this.showCode2,
          showCode3: this.showCode3,
          showCode4: this.showCode4,
          showCode5: this.showCode5,
          showCode6: this.showCode6,
          showCode7: this.showCode7,
          showCode8: this.showCode8,
          showCode9: this.showCode9,
          showCode10: this.showCode10,
        }
        window.localStorage.setItem('showCodeStates', JSON.stringify(showCodeStates))

        // return
        console.log("rinputNumes - - -", inputNum);

        // code_type 1-激活码 2-串号 3-信息
        if (code_type == 1) {
          this.$router.push({
            path: '/scanCodePage?ind=' + inputNum + '&code_type=1'
          })
        } else if (code_type == 2) {
          this.$router.push({
            path: '/scanCodePage?code_type=2'
          })
        }

        window.localStorage.removeItem('_scanCode_1_1')
        window.localStorage.removeItem('_scanCode_2_1')
        window.localStorage.removeItem('_scanCode_3_1')
        window.localStorage.removeItem('_scanCode_4_1')
        window.localStorage.removeItem('_scanCode_5_1')
        window.localStorage.removeItem('_scanCode_6_1')
        window.localStorage.removeItem('_scanCode_7_1')
        window.localStorage.removeItem('_scanCode_8_1')
        window.localStorage.removeItem('_scanCode_9_1')
        window.localStorage.removeItem('_scanCode_10_1')
        window.localStorage.removeItem('_scanCode_2')

      
      },

      serialScan() {
        getScanCode().then((res) => {
     
          this.formData.serialNum = res;
        });
      },
      onConfirm2(value) {
        this.formData.purchasTime = value;
        this.purchasTime = dayjs(value).format("YYYY-M-D");
        this.showTime = false;
      },
      showDalog() {
        if (!this.formData.codeCertificate) {
          this.$toast("请先上传图片");
        } else {
          this.dialogShow = true;
        }
      },
      async onSubmit(e) {
        this.dialogShow = false;
        this.showLoding = true;
        let data = JSON.parse(JSON.stringify(this.formData));
        data.purchasTime = this.purchasTime;
        if (data.code2) {
          let data2 = {
            ...data,
            code: data.code2,
          };
          const res = await saveUserInfo(data2);
          const response = res.data;
          if (response.code !== "200") {
            this.$toast.fail("激活码2" + response.msg);
          }
        }
        if (data.code3) {
          let data3 = {
            ...data,
            code: data.code3,
          };
          const res = await saveUserInfo(data3);
          const response = res.data;
          if (response.code !== "200") {
            this.$toast.fail("激活码3" + response.msg);
          }
        }
        if (data.code4) {
          let data4 = {
            ...data,
            code: data.code4,
          };
          const res = await saveUserInfo(data4);
          const response = res.data;
          if (response.code !== "200") {
            this.$toast.fail("激活码4" + response.msg);
          }
        }
        if (data.code5) {
          let data5 = {
            ...data,
            code: data.code5,
          };
          const res = await saveUserInfo(data5);
          const response = res.data;
          if (response.code !== "200") {
            this.$toast.fail("激活码5" + response.msg);
          }
        }
        if (data.code6) {
          let data6 = {
            ...data,
            code: data.code6,
          };
          const res = await saveUserInfo(data6);
          const response = res.data;
          if (response.code !== "200") {
            this.$toast.fail("激活码6" + response.msg);
          }
        }
        if (data.code7) {
          let data7 = {
            ...data,
            code: data.code7,
          };
          const res = await saveUserInfo(data7);
          const response = res.data;
          if (response.code !== "200") {
            this.$toast.fail("激活码7" + response.msg);
          }
        }
        if (data.code8) {
          let data8 = {
            ...data,
            code: data.code8,
          };
          const res = await saveUserInfo(data8);
          const response = res.data;
          if (response.code !== "200") {
            this.$toast.fail("激活码8" + response.msg);
          }
        }
        if (data.code9) {
          let data9 = {
            ...data,
            code: data.code9,
          };
          const res = await saveUserInfo(data9);
          const response = res.data;
          if (response.code !== "200") {
            this.$toast.fail("激活码9" + response.msg);
          }
        }
        if (data.code10) {
          let data10 = {
            ...data,
            code: data.code10,
          };
          const res = await saveUserInfo(data10);
          const response = res.data;
          if (response.code !== "200") {
            this.$toast.fail("激活码10" + response.msg);
          }
        }
        saveUserInfo(data).then((res) => {
          const response = res.data;
          if (response.code === "200") {
            getUserInfo({
              keyword: this.formData.code
            }).then((res2) => {
              console.log(res2);
              const data = res2.data.data[0];
              if (data) {
                const {
                  code
                } = data;
                this.$router.push({
                  path: "/codeDetail",
                  query: {
                    code,
                  },
                });
              } else {
                this.$toast.success({
                  message: "信息已提交，等待工作人员审核",
                  duration: 5000,
                });
              }
            });
          } else {
            this.$toast.fail(response.msg);
          }
          this.showLoding = false;
        });
      },
      onConfirm(value) {
        this.brandName = value.brandName;
        this.formData.brandId = value.brandId;
        this.showPicker = false;
      },
      afterRead(file) {
        console.log(file);
        if (!this.formData.code) {
          this.$toast.fail("请先填写激活码");
          return;
        }
        this.showLoding = true;
        var formData = new FormData();
        formData.append("picture", file.file);
        formData.append("code", this.formData.code);
        formData.append("name", "code_certificate");
        uploadImg(formData)
          .then((res) => {
            const response = res.data;
            if (response.code === "200") {
              this.formData.codeCertificate = response.data;
              checkImgFun(response.data).then((url) => {
                this.codeCertificate = url;
              });
              this.$toast.success("上传成功");
            } else {
              this.$toast.fail(response.msg);
            }
            this.showLoding = false;
          })
          .catch(() => {
            this.$toast.fail("上传失败,请重新上传");
            this.showLoding = false;
          });
      },
      afterRead2(file) {
        console.log(file);
        this.showLoding = true;
        var formData = new FormData();
        formData.append("picture", file.file);
        formData.append("code", this.formData.code);
        formData.append("name", "code_certificate2");
        uploadImg(formData)
          .then((res) => {
            const response = res.data;
            if (response.code === "200") {
              this.formData.codeCertificate3 = response.data;
              checkImgFun(response.data).then((url) => {
                this.codeCertificate3 = url;
              });
              this.$toast.success("上传成功");
            } else {
              this.$toast.fail(response.msg);
            }
            this.showLoding = false;
          })
          .catch(() => {
            this.$toast.fail("上传失败,请重新上传");
            this.showLoding = false;
          });
      },
      afterRead3(file) {
        console.log(file);
        this.showLoding = true;
        var formData = new FormData();
        formData.append("picture", file.file);
        formData.append("code", this.formData.code);
        formData.append("name", "code_certificate3");
        uploadImg(formData)
          .then((res) => {
            const response = res.data;
            if (response.code === "200") {
              this.formData.codeCertificate4 = response.data;
              checkImgFun(response.data).then((url) => {
                this.codeCertificate4 = url;
              });
              this.$toast.success("上传成功");
            } else {
              this.$toast.fail(response.msg);
            }
            this.showLoding = false;
          })
          .catch(() => {
            this.$toast.fail("上传失败,请重新上传");
            this.showLoding = false;
          });
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
  .wrapper {
    .icon-box {
      margin-left: 15px;
    }

    background: url("https://www.servicefun.cn/static/img/bg.png") no-repeat;
    overflow: auto;
    background-size: 100%;
    background-color: #f0f0f0;

    .picker-field.picker-inputed {
      /deep/ .van-field__control {
        color: #323233;
        -webkit-text-fill-color: #323233;
      }
    }

    .picker-field {
      /deep/ .van-cell__title {
        position: absolute;
        width: 100%;
        z-index: 1;
        color: #646566;
      }

      /deep/ .van-cell__value {
        color: #8e8e8e;
        padding-left: 100px;
      }

      /deep/ .van-field__control {
        color: #8e8e8e;
        -webkit-text-fill-color: #8e8e8e;
      }
    }

    .formWrapper {
      width: 340px;
      background: #fff;
      margin: 0 auto;
      margin-top: 36px;
      border-radius: 10px;
      overflow: hidden;
      padding-bottom: 20px;
    }

    .panel {
      .title {
        padding: 10px 16px;
      }

      /deep/ ._van_btn {
        .van-field__button {
          margin-top: -6px;
        }
      }

      /deep/ .van-uploader {
        width: 300px;
        padding: 10px 16px;
      }

      .upladerBtn {
        border: none;
        font-size: 40px;
        width: 300px;
        height: 240px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-color: gray;
        background-image: url(https://www.servicefun.cn/static/img/exrample.jpeg);
      }
    }

    .discription {
      padding: 10px 16px;
      font-size: 12px;
      color: #908c8c;

      p {
        margin-top: 6px;
        line-height: 20px;
      }
    }
  }

  .copyright {
    display: block;
    margin-bottom: 10px;
    margin-top: 100px;
    color: #2b3135;
    text-align: center;
    font-size: 12px;
  }

  .dialog {
    padding: 10px;

    p {
      font-size: 12px;
      line-height: 20px;
    }

    .indent {
      text-indent: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/activationCode/index.vue